import { useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { useFormat } from 'helpers/hooks/useFormat';

type SectionProps = { title: string; subtitle: string; cta: string; onClick: () => void };
type BottomSectionDataType = { [key in 'user' | 'guest']: SectionProps };

const useBottomSectionProps = (loggedIn: boolean) => {
  const router = useRouter();
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const bottomSectionOptions: BottomSectionDataType = useMemo(() => {
    return {
      user: {
        title: formatMessage({ id: 'thankyou.userTitle', defaultMessage: 'I miei ordini' }),
        subtitle: formatMessage({
          id: 'thankyou.userSubtitle',
          defaultMessage: 'Visualizza e gestisci i tuoi ordini',
        }),
        cta: formatMessage({ id: 'thankyou.userCta', defaultMessage: 'Review order status' }),
        onClick: () => router.push('/account#orders'),
      },
      guest: {
        title: formatMessage({ id: 'thankyou.guestTitle', defaultMessage: 'Salva le tue informazioni' }),
        subtitle: formatMessage({
          id: 'thankyou.guestSubtitle',
          defaultMessage:
            'Approfitta di un checkout più veloce, della cronologia degli ordini e di offerte personalizzate.',
        }),
        cta: formatMessage({ id: 'thankyou.guestCta', defaultMessage: 'Crea un account' }),
        onClick: () => router.push('/register'),
      },
    };
  }, [formatMessage, router]);

  const bottomSectionProps = useMemo(() => {
    return loggedIn ? bottomSectionOptions['user'] : bottomSectionOptions['guest'];
  }, [bottomSectionOptions, loggedIn]);

  return { bottomSectionProps };
};
export default useBottomSectionProps;
